module.exports = __webpack_public_path__ + "static/media/nurs.9691eb93.jpg";